import React, { Fragment } from 'react'
import Helmet from 'react-helmet'
import Link from 'gatsby-link'
import Header from '../../components/Header'
import hero from '../../images/why-ati__hero.jpg'
import img01 from '../../images/why-ati-1.jpg'
import img02 from '../../images/why-ati-2.jpg'
import img03 from '../../images/why-ati-3.jpg'

const Page = () => (
  <Fragment>
    <Helmet
      title="Why ATI | Who We Are"
      // meta={[{ name: 'description', content: '' }]}
    />
    <Header hero={hero}>
      <h1 className="t-hero">Why ATI</h1>
    </Header>
    <main id="content">
      <div className="c-golden t-context--light">
        <div className="c-golden__content c-golden__wide">
          <ul className="c-breadcrumbs mb30">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/who-we-are">Who We Are</Link>
            </li>
            <li>
              <Link to="/who-we-are/why-ati" activeClassName="is-active">
                Why ATI
              </Link>
            </li>
          </ul>
          <div className="c-golden__text">
            <div className="c-golden__text-col">
              <h1 className="t-h1" style={{ maxWidth: '14em' }}>
                Bringing the world to America for over 40 years
              </h1>
              <p className="t-p t-p-light mt30">
                ATI’s product range and service expertise is unparalleled. Our
                industry leading escorted tour programs are guaranteed to
                operate in multiple languages. Since not everyone wants to
                follow a set itinerary, the flexible and dynamic packaging
                technology behind our DriveAmerica™ self-drive programs allows
                our clients to customize their own great American road trip.
                And, our team of group travel experts stands at the ready to
                deploy their destination knowledge and industry relationships to
                facilitate any meeting, incentive, or group leisure programs
                brought our way.
              </p>
              <p className="t-p t-p-light mt30">
                ATI is your one-stop-shop for all your North America product and
                service needs. We would like to take this opportunity to
                sincerely thank you for your valued support and for enabling us
                to share the American Dream with the clients you entrust to us.
              </p>
            </div>
          </div>
          <div className="c-golden__next-page">
            <Link
              to="/who-we-are/whats-new"
              className="c-btn t-link mt30"
            >
              What's New &nbsp;&#9654;
            </Link>
          </div>
        </div>
        <div className="c-golden__images c-golden__short min-laptop">
          <img src={img01} alt="" style={{ width: '50%', height: '50%' }} />
          <img src={img02} alt="" style={{ width: '50%', height: '50%' }} />
          <img src={img03} alt="" style={{ width: '100%', height: '50%' }} />
        </div>
      </div>
    </main>
  </Fragment>
)

export default Page



// WEBPACK FOOTER //
// ./src/pages/who-we-are/why-ati.js